import api from 'api'

export const signIn = async (payload) => {
  const { data } = await api.post('/login', payload)

  return data
}
